var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow2Left = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "8 10 14 9.333"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.415 14.083H9.949l3.136-3.123a.56.56 0 0 0 0-.795.566.566 0 0 0-.799 0L8.165 14.27a.56.56 0 0 0 0 .795l4.121 4.104c.221.22.578.22.799 0a.56.56 0 0 0 0-.795L9.949 15.25h11.466a.59.59 0 0 0 .585-.584.59.59 0 0 0-.585-.583"
})));
export default SvgArrow2Left;